var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12427_45799)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12427_45799",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.704834 0.165871H42.3715V41.8325H0.704834V0.165871Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12427_45799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31519 9.44313V4.43052C1.31519 3.98105 1.67961 3.61671 2.12899 3.61671H40.9473C41.3967 3.61671 41.7611 3.98105 41.7611 4.43052V34.1945C41.7611 34.6439 41.3967 35.0083 40.9473 35.0083H32.6059",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9845 35.0088H2.12899C1.67961 35.0088 1.31519 34.6445 1.31519 34.195V12.5361",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2646 22.8709V6.10743H3.81189V32.5176H28.8625",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.647 32.5176H39.2649V26.1261",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61975 11.2168H29.6604",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61975 14.9292H34.4559",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61975 18.6416H23.2986",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48295 28.9643C10.2718 26.8875 10.622 24.6756 10.6792 22.4606C10.2797 22.5147 9.88 22.5687 9.48042 22.6229C9.7515 24.2487 9.77298 25.9734 10.5319 27.4734C10.8884 28.1778 11.6154 28.5945 12.3932 28.2811C13.0494 28.0168 13.5724 27.2875 13.7727 26.6261H12.5957C12.6805 27.0665 12.918 27.5205 13.2327 27.8382C13.8247 28.4357 14.6033 28.3718 15.3777 28.3708C16.5859 28.3693 17.7942 28.3664 19.0025 28.363C19.7879 28.3608 19.7893 27.1401 19.0025 27.1423C17.9665 27.1452 16.9305 27.1477 15.8946 27.1493C15.5617 27.1499 15.2289 27.1504 14.8962 27.1506C14.6415 27.1508 14.3667 27.1958 14.1515 27.0314C13.9107 26.8474 13.8278 26.5877 13.7727 26.3016C13.6534 25.6819 12.7595 25.7608 12.5957 26.3016C12.5231 26.5411 12.1569 27.2266 11.837 27.1706C11.6675 27.1409 11.5935 26.8794 11.5308 26.744C11.4088 26.4804 11.3199 26.2011 11.2439 25.9211C10.9226 24.7383 10.8584 23.5034 10.6575 22.2983C10.541 21.5995 9.4757 21.7971 9.45853 22.4606C9.40393 24.5741 9.0583 26.6587 8.30586 28.6397C8.02665 29.3748 9.20633 29.6927 9.48295 28.9643Z",
    fill: "#70C1AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5156 28.6976V38.3818L30.7659 37.568L29.0162 38.3818V28.6976",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7653 29.9131C30.1479 29.9131 29.7436 28.8621 29.2067 28.6391C28.6502 28.4079 27.6245 28.8559 27.205 28.4357C26.7857 28.0155 27.2328 26.988 27.002 26.4304C26.7793 25.8925 25.7303 25.4875 25.7303 24.869C25.7303 24.2504 26.7793 23.8454 27.002 23.3075C27.2328 22.75 26.7857 21.7224 27.205 21.3022C27.6245 20.882 28.6502 21.33 29.2067 21.0988C29.7436 20.8758 30.1479 19.8249 30.7653 19.8249C31.3827 19.8249 31.787 20.8758 32.3239 21.0988C32.8804 21.33 33.9061 20.8821 34.3256 21.3022C34.7449 21.7225 34.2978 22.75 34.5286 23.3075C34.7512 23.8454 35.8003 24.2504 35.8003 24.869C35.8003 25.4875 34.7512 25.8925 34.5285 26.4304C34.2978 26.988 34.7449 28.0155 34.3255 28.4357C33.9061 28.8559 32.8804 28.4079 32.3239 28.6392C31.787 28.8621 31.3827 29.9131 30.7653 29.9131Z",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.539 24.869C32.539 25.8486 31.7449 26.6426 30.7653 26.6426C29.7858 26.6426 28.9917 25.8486 28.9917 24.869C28.9917 23.8894 29.7858 23.0954 30.7653 23.0954C31.7449 23.0954 32.539 23.8894 32.539 24.869Z",
    stroke: "#70C1AC",
    strokeWidth: 1.2207,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12427_45799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6667,
    height: 41.6666,
    fill: "white",
    transform: "translate(0.703735 0.166504)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.88a6631c0d0200173ec95ee0ca0c73bd.svg";
export { ForwardRef as ReactComponent };